import { createSlice } from "@reduxjs/toolkit";
import { status } from "../../_constants/common";
import { getGroupedOrders, getOrderDetails , getWithItems} from "./OrderThunk";

const initialState = {
    // groupedOrders: {
    //     data: null,
    //     status: status.IDLE,
    //     error: null,
    // },
    withItems: {
        data: null,
        status: status.IDLE,
        error: null,
    },
    orderDetails: {
        data: null,
        status: status.IDLE,
        error: null,
    },
};

const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        resetOrderState: (state) => {
            state.groupedOrders = initialState.groupedOrders;
            state.withItems = initialState.withItems;
            state.orderDetails = initialState.orderDetails;
        },
        resetOrderDetails: (state) => {
            state.orderDetails = initialState.orderDetails;
        },
    },
    extraReducers: (builder) => {
        // Get grouped orders
        // builder.addCase(getGroupedOrders.pending, (state) => {
        //     state.groupedOrders.status = status.LOADING;
        // });
        // builder.addCase(getGroupedOrders.fulfilled, (state, action) => {
        //     state.groupedOrders.status = status.SUCCESS;
        //     state.groupedOrders.data = action.payload;
        //     state.groupedOrders.error = null;
        // });
        // builder.addCase(getGroupedOrders.rejected, (state, action) => {
        //     state.groupedOrders.status = status.FAILED;
        //     state.groupedOrders.error = action.payload;
        // });

        // Get orders with items
        builder.addCase(getWithItems.pending, (state) => {
            state.withItems.status = status.LOADING;
        });
        builder.addCase(getWithItems.fulfilled, (state, action) => {
            state.withItems.status = status.SUCCESS;
            state.withItems.data = action.payload;
            state.withItems.error = null;
        });
        builder.addCase(getWithItems.rejected, (state, action) => {
            state.withItems.status = status.FAILED;
            state.withItems.error = action.payload;
        });

        // Get order details
        builder.addCase(getOrderDetails.pending, (state) => {
            state.orderDetails.status = status.LOADING;
        });
        builder.addCase(getOrderDetails.fulfilled, (state, action) => {
            state.orderDetails.status = status.SUCCESS;
            state.orderDetails.data = action.payload;
            state.orderDetails.error = null;
        });
        builder.addCase(getOrderDetails.rejected, (state, action) => {
            state.orderDetails.status = status.FAILED;
            state.orderDetails.error = action.payload;
        });
    },
});

export const { resetOrderState, resetOrderDetails } = orderSlice.actions;

export default orderSlice.reducer;
